import { render } from "./AddInsertsTemplate.vue?vue&type=template&id=a933c984"
import script from "./AddInsertsTemplate.vue?vue&type=script&lang=js"
export * from "./AddInsertsTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__